import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "url-polyfill";

import FullPage from "@ubisend/pulse-full-page-boost";

FullPage.render();
